// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"7eae160e","510":"c1db7c77","728":"9d88dfc1","787":"9af8d78b","789":"44a3a66d","865":"482ef8ae","962":"ca5d1209"}[chunkId] + ".chunk.js";
};